<template>
	<div>
		<StreetsScroller ref="streets_scroller" />

		<section
			class="transactionsSection"
			v-show="currentTransactions.length > 0"
		>
			<div class="transactions container-fluid sectionPadBottom">
				<div class="tableContainer">
					<div
						v-if="inProgress == true"
						style="position: relative; height: 770px"
					>
						<svg
							style="
								margin: 0;
								position: absolute;
								top: 50%;
								left: 50%;
								-ms-transform: translate(-50%, -50%);
								transform: translate(-50%, -50%);
							"
							viewBox="25 25 50 50"
							class="loader-svg"
						>
							<circle
								class="loader-path"
								cx="50"
								cy="50"
								r="20"
								fill="none"
								stroke="#1990d4"
								stroke-width="2"
							/>
						</svg>
					</div>
					<div v-if="inProgress == false" class="accordion">
						<TableBox></TableBox>
					</div>
				</div>
			</div>
		</section>
		
	</div>
</template>

<script></script>

<script>
	import StreetsScroller from "./StreetsScroller";
	import NeighScroller from "./NeighScroller";
	import TableBox from "./TableBox";

	export default {
		name: "AdditionalDeals",
		props: {
			msg: String,
		},
		components: {
			NeighScroller,
			StreetsScroller,
			TableBox,
		},
		data() {
			return {
				base_level_id: null,
				base_level: null,
				initialDeals: [],
				inProgress: false,
				total_rows: 0,
				currentPage: 1,
				transactions: [],
				currentPage: 1,
				totalPages: 0,
				currentTransactions: [],
				currentFetchNumber: 1,
				base_id: 0,
				base_name: "",
				hok_hamecher: "",
				deal_nature: "",
				deal_date: "",

				filter_rooms_hovered: false,
				sort_hovered: false,
				filter_hovered: false,
				countDealsAll: 0,
				centerIndex: -1,
				scrollPosition: 0,
				contentWidth: 0,
				showFilterOptions: false,
				dealsPeriodOptions: [
					{ value: "all", text: "כל העסקאות מכל הזמנים" },
					{ value: "3months", text: "3 חודשים אחרונים" },
					{ value: "6months", text: "חצי שנה האחרונה" },
					{ value: "year", text: "שנה האחרונה" },
					{ value: "5years", text: "חמש שנים האחרונות" },
				],
				selectedDealsPeriod: "כל העסקאות מכל הזמנים",
				showDealsPeriods: false,
				selectedAssetType: "כל סוגי הנכסים",
				showAssetTypes: false,
				assetTypeOptions: [
					{ value: "all", text: "כל סוגי הנכסים" },
					{ value: "apartment", text: "דירה" },
					{ value: "penthouse", text: "פנטהאוז" },
					{ value: "private_house", text: "בית פרטי" },
					{ value: "commercial", text: "מסחר" },
					{ value: "other", text: "שונות" },
				],
				showDealTypes: false,
				dealTypeOptions: [
					{ value: "all", text: "כל העסקאות" },
					{ value: "first_hand", text: "יד ראשונה" },
					{ value: "second_hand", text: "יד שניה" },
				],
				selectedDealType: "כל העסקאות",
				similarNeighborhoods: [
					{ neighborhoodId: 65209720, neighborhoodName: "מרכז" },
					{ neighborhoodId: 65210202, neighborhoodName: "פועלים ב" },
					{ neighborhoodId: 65209721, neighborhoodName: "שיכוני מזרחי" },
					{ neighborhoodId: 65210764, neighborhoodName: "מעוז" },
				],
				otherNeighborhoodStreets: [],
				activeIndex: 0,

				sortOptions: [
					{ value: "dateDesc", text: "תאריך עסקה - סדר יורד" },
					{ value: "dateAsc", text: "תאריך עסקה - סדר עולה" },
					{ value: "priceDesc", text: "מחיר העסקה - סדר יורד" },
					{ value: "priceAsc", text: "מחיר העסקה - סדר עולה" },
					{ value: "roomNumDesc", text: "מס' חדרים - סדר יורד" },
					{ value: "roomNumAsc", text: "מס' חדרים - סדר עולה" },
				],
				selectedSortOption: "dateDesc",
				roomOptions: [
					{ value: 1, image: "/images/1rooms.png", text: "1 חדרים" },
					{ value: 2, image: "/images/2rooms.png", text: "2 חדרים" },
					{ value: 3, image: "/images/3rooms.png", text: "3 חדרים" },
					{ value: 4, image: "/images/4rooms.png", text: "4 חדרים" },
					{ value: 5, image: "/images/5rooms.png", text: "5 חדרים" },
					{ value: 6, image: "/images/6rooms.png", text: "6+ חדרים" },
				],
				showRoomsMenu: false,
				tabs: [
					{ key: "all", label: "כל החדרים" },
					{ key: "3", label: "3 חדרים" },
					{ key: "4", label: "4 חדרים" },
					{ key: "5", label: "5 חדרים" },
				],
				selectedTab: "all",
				toggle_exclusive: 0,
				luxury: null,
				priceIncreases: null,
				Yield: null,

				lastYearAvgPrice: null,
				lastYearAvgPrice_3: null,
				lastYearAvgPrice_4: null,
				lastYearAvgPrice_5: null,

				selectedRow: null,
				colspan: 2, // Number of columns in the main table,
				selected_deals: [],
				page: 1,
				selectedRooms: [],
				showSort: false,
				sortType: null,

				current: 1,
				deals: [],
				streetId: null,

				summaryTypeName: "",
			};
		},
		methods: {
			PageIsAddressOrParcel() {
				return false;
			},
			parcel_dataHead() {
				if (!this.isMobile) {
					return "גוש/חלקה/תת-חלקה";
				} else {
					return "תת-חלקה";
				}
			},
			login() {
				this.mixin_goTo(this, "login");
			},
			async callMixinShowResults() {
				// Call the mixin function and wait for it to finish
				if (
					this.$store.state.search == null ||
					this.$store.state.search == ""
				) {
					if (this.$store.state.searchType == "NEIGHBORHOOD") {
						this.$store.state.search ==
							this.$store.state.neighborhoodName +
								", " +
								this.$store.state.settlementName;
					} else if (this.$store.state.searchType == "SETTLEMENT") {
						this.$store.state.search == this.$store.state.settlementName;
					} else if (this.$store.state.searchType == "STREET") {
						this.$store.state.search ==
							this.$store.state.streetName +
								", " +
								this.$store.state.settlementName;
					} else if (this.$store.state.searchType == "ADDRESS") {
						this.$store.state.search ==
							this.$store.state.streetName +
								" " +
								this.$store.state.houseNumber +
								", " +
								this.$store.state.settlementName;
					} else {
						this.$store.state.search ==
							this.$store.state.neighborhoodName +
								", " +
								this.$store.state.settlementName;
					}
				}
				await this.mixin_showResults(this); // Pass the component instance as an argument
				var routeName = "settlement";
				// check if neighborhoodId is null
				if (this.$store.state.neighborhoodId > 0) {
					routeName = "neighborhood";
				}
				var appVue = this;
				if (routeName != "settlement") {
					if (this.$store.state.neighborhoodId == null) {
						await this.mixin_waitForNeighUpdate(appVue);
					}
					// appVue.mixin_getDealsData(
					// 	appVue,
					// 	"NEIGHBORHOOD",
					// 	appVue.$store.state.neighborhoodId,
					// );
				} else {
					await this.mixin_waitForSetlUpdate(appVue);
					appVue.mixin_getDealsData(
						appVue,
						"SETTLEMENT",
						appVue.$store.state.setlCode,
					);
				}
				appVue.loading = false;
			},
			waitForSetlUpdate() {
				return new Promise((resolve) => {
					// Watch for changes in the state
					const unwatch = this.$watch(
						() => this.$store.state.setlCode,
						(newValue, oldValue) => {
							// Check if the setlCode has been updated
							if (newValue !== oldValue) {
								// If updated, resolve the promise
								resolve();
								// Stop watching for changes
								unwatch();
							}
						},
					);
				});
			},
			waitForConfigUpdate() {
				return new Promise((resolve) => {
					// Watch for changes in the state
					const unwatch = this.$watch(
						() => this.$store.state.config,
						(newValue, oldValue) => {
							// Check if the config has been updated
							if (newValue !== oldValue) {
								// If updated, resolve the promise
								resolve();
								// Stop watching for changes
								unwatch();
							}
						},
					);
				});
			},
			updateUrlParcel(polygonId) {
				if (polygonId.includes("-")) {
					if (this.$route.params.kParcel != polygonId) {
						this.$router.push({
							name: "kparcel_all",
							params: { kParcel: polygonId },
						});
						setTimeout(() => {
							window.location.reload();
							//go to top
							window.scrollTo(0, 0);
						}, 10);

						var params = {
							layerName: "KSHTANN_ASSETS",
							fieldName: "ID",
							fieldValues: [polygonId],
							highlight: true,
						};
						govmap.searchInLayer(params);

						window.location.reload();
					}
				}
			},
			updateUrl(addressId) {
				if (this.$route.query.id != addressId) {
					const origin = window.location.origin;
					const target = "view=address&id=" + addressId + "&page=deals";
					// redirect to origin + target
					window.location.href = origin + "/?" + target;
					// refresh the page
					setTimeout(() => {
						//window.location.reload();
						//go to top
						window.scrollTo(0, 0);
					}, 10);
				}
				//
			},
			selectStreet(streetId) {
				this.streetId = streetId;
				//this.page = 1;
				this.currentFetchNumber = 1;
				this.transactions = [];
				this.currentPage = 1;
				this.fetchData();
			},
			zoomRow(e) {
				const polygonId = e.polygonId;

				// select feature
				// select feature on map
				govmap.searchInLayer({
					layerName: "KSHTANN_ASSETS",
					fieldName: "POLYGON_ID",
					fieldValues: [polygonId],
					highlight: true,
					outLineColor: [0, 0, 255, 1],
					fillColor: [0, 0, 255, 0.5],
				});
			},
			filterDealsPeriods(value, text) {
				// get selected deals period
				this.selectedDealsPeriod = text;
			},
			filterAssetType(value, text) {
				// get selected asset type
				this.selectedAssetType = text;
			},
			filterDealType(value, text) {
				// get selected deal type
				this.selectedDealType = text;
			},
			goToNeighborhood(neighborhoodId) {
				// get the base url domain...
				const baseUrl = window.location.protocol + "//" + window.location.host;
				const newPath = baseUrl + `/neighborhood/${neighborhoodId}/buy/deals`;

				// Navigate to the new URL using window.location
				window.location.href = newPath;
			},

			tableSort(sortValue) {
				this.selectedSortOption = sortValue;
				// Here you can add any additional logic for handling the selected sort option
				switch (sortValue) {
					case "dateDesc":
						this.deals.sort(
							(a, b) => new Date(a.dealDate) - new Date(b.dealDate),
						);
						break;
					case "dateAsc":
						this.deals.sort(
							(a, b) => new Date(b.dealDate) - new Date(a.dealDate),
						);
						break;
					case "priceDesc":
						this.deals.sort(
							(a, b) =>
								parseFloat(a.dealAmount.replace(/,|₪/g, "")) -
								parseFloat(b.dealAmount.replace(/,|₪/g, "")),
						);
						break;
					case "priceAsc":
						this.deals.sort(
							(a, b) =>
								parseFloat(b.dealAmount.replace(/,|₪/g, "")) -
								parseFloat(a.dealAmount.replace(/,|₪/g, "")),
						);
						break;
					case "roomNumDesc":
						this.deals.sort((a, b) => a.roomNum - b.roomNum);
						break;
					case "roomNumAsc":
						this.deals.sort((a, b) => b.roomNum - a.roomNum);
						break;
					default:
						this.deals.sort(
							(a, b) => new Date(a.dealDate) - new Date(b.dealDate),
						);
						break;
				}
			},
			toggleShowFilter() {
				this.showFilterOptions = !this.showFilterOptions;
			},
			toggleShowSort() {
				this.showSort = !this.showSort;
			},
			isSelected(roomValue) {
				return this.selectedRooms.includes(roomValue);
			},
			toggleRoom(roomValue) {
				this.page = 1;
				if (this.isSelected(roomValue)) {
					this.selectedRooms = this.selectedRooms.filter(
						(value) => value !== roomValue,
					); // Remove the room
				} else {
					this.selectedRooms.push(roomValue); // Add the room
				}
			},
			customSort(a, b) {
				return a.toDate() - b.toDate();
			},
			go() {
				const userData = this.mixin_getCookie("user");

				if (userData == null) {
					if (this.currentPage >= 100) {
						this.$parent.userLimitModal = true;
						return;
					} else {
						this.$parent.userLimitModal = false;
					}
				}

				if (this.currentPage < this.totalPages) {
					this.currentPage++;
					this.updateTransactions();
				}
			},
			updateTransactions() {
				const newFetchNumber = Math.floor((this.currentPage - 1) / 50) + 1;
				if (newFetchNumber !== this.currentFetchNumber) {
					this.currentFetchNumber = newFetchNumber;
					this.transactions = [];
					this.fetchData();
				} else {
					this.displayTransactions();
				}
			},
			goBack2() {
				if (this.page > 1) {
					this.page = this.page - 1;
				}
			},
			goBack() {
				if (this.currentPage > 1) {
					this.currentPage--;
					this.updateTransactions();
				}
			},
			toggleCollapse(index) {
				this.selectedRow = this.selectedRow === index ? null : index;
			},
			isCollapsed(index) {
				return this.deals[index].collapsed;
			},
			selectTab(tab) {
				// Remove 'active' class from all tabs
				this.tabs.forEach((t) => {
					const element = document.querySelector(
						`[data-rb-event-key="${t.key}"]`,
					);
					if (element) {
						element.classList.remove("active");
					}
				});

				// Add 'active' class to the selected tab
				this.selectedTab = tab.key;
				const selectedElement = document.querySelector(
					`[data-rb-event-key="${tab.key}"]`,
				);
				if (selectedElement) {
					selectedElement.classList.add("active");
				}

				// set graph data here
				if (this.$refs.graph_card != null) {
					this.$refs.graph_card.UpdateChart(this.selectedYears);	
				}
			},

			async fetchData() {
				this.inProgress = true;
				if (this.streetId > 0) {
					this.base_name = "streetCode";
					this.base_id = this.streetId;
				} else {
					this.base_name = this.base_level;
					this.base_id = this.base_level_id;
				}

				// console.log("*", this.$store.state.base_name, this.$store.state.base_id);
				// this.base_id = this.$store.state.base_id;
				// this.base_name = this.$store.state.base_name;
				const requestData = {
					base_id: this.base_id,
					base_name: this.base_name,
					fetch_number: this.currentFetchNumber,
					type_order: "dealDate_down",
					// ... and so on
				};

				if (this.selectedRooms.length > 0) {
					requestData.room_num = this.selectedRooms.join(",");
				}

				if (this.type_order) {
					requestData.type_order = this.type_order;
				}
				if (this.hok_hamecher) {
					requestData.hok_hamecher = this.hok_hamecher;
				}
				if (this.deal_nature) {
					requestData.deal_nature = this.deal_nature;
				}
				if (this.deal_date) {
					requestData.deal_date = this.deal_date;
				}

				const myHeaders = new Headers();
				myHeaders.append("Content-Type", "text/plain");
				const token = await this.mixin_generateToken();
				requestData.sk = token;
				const userData = this.mixin_getCookie("user");
				if (userData) {
					requestData.email = userData.useremail;
					requestData.userid = userData.userid;
				}
				var requestDataGen = await this.mixin_generateTokenForPayload(requestData);
				const raw = JSON.stringify(requestDataGen);
				const requestOptions = {
					method: "POST",
					headers: myHeaders,
					body: raw,
					redirect: "follow",
				};
				var appVue = this;
				fetch(appVue.$store.state.config.api_base + "/deal", requestOptions)
					.then((response) => response.json())
					.then((data) => {
						// decompressBase64Gzip
						var data = this.decompressBase64Gzip(data);
						if (data.data.items.length == 0) {
							appVue.transactions = [];
							appVue.totalPages = 0;
							appVue.total_rows = 0;
							appVue.inProgress = false;
							return;
						}
						
						// filter prevDeals
						for (var i = 0; i < data.data.items.length; i++) {
							var element = data.data.items[i];
							if (data.data.items[i].hasOwnProperty("prevDeals")) {
								if (element.trend.rate == 0 ||
									element.trend.years == 0 ||
									element.trend.years > 9 && element.trend.rate > 500 ||
									element.trend.years > 2 && element.trend.rate < -50 ||
									// current year
									element.yearBuilt >= new Date().getFullYear()){
										// exclude i from prevDeals
										data.data.items[i].prevDeals = [];
								}
							}
						}
						
						appVue.setFancyRows(data.data);
						appVue.transactions = data.data.items;
						appVue.totalPages = Math.ceil(data.data.total_rows / 10);
						if (this.initialDeals.length == 0) {
							this.initialDeals = data.data.items;
						}
						appVue.displayTransactions();
						this.total_rows = data.data.total_rows;
						this.inProgress = false;
					})
					.catch((error) => console.error(error));
			},
			displayTransactions() {
				const startIndex = ((this.currentPage - 1) % 50) * 10;
				const endIndex = startIndex + 10;
				this.currentTransactions = this.transactions.slice(
					startIndex,
					endIndex,
				);
			},
			setFancyRows(e) {
				e.items.forEach((element) => {
					element.dealAmount =
						element.dealAmount.toLocaleString("he-IL") + " ₪";
					// get date
					// exmple: 2023-02-09T02:00:00+02:00
					// format to 'DD/MM/YYYY'
					const date = new Date(element.dealDate);
					var parentDealDate = element.dealDate;
					const day = date.getDate().toString().padStart(2, "0");
					const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Month is zero-based, so we add 1
					const year = date.getFullYear();
					const formattedDate = `${day}/${month}/${year}`;
					element.dealDate = formattedDate;
					if (element.hasOwnProperty("prevDeals")) {
						element.prevDeals.forEach((i) => {
							const date = new Date(i.dealDate);
							if (i.dealDate == parentDealDate ||
								element.trend.years > 9 && element.trend.rate > 300 ||
								element.trend.years > 2 && element.trend.rate < -50
							) {
								// exclude i from prevDeals
								element.prevDeals.splice(
									element.prevDeals.indexOf(i),
									1,
								);
								return;
							}
							const day = date.getDate().toString().padStart(2, "0");
							const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Month is zero-based, so we add 1
							const year = date.getFullYear();
							const formattedDate = `${day}/${month}/${year}`;
							i.dealDate = formattedDate;
						});
					}
					//trend
					let rate = element.trend.rate;
					let years = element.trend.years;
					let trend = `${rate}% ב ${years} שנים`;
					if (
						element.trend.hasOwnProperty("rate") == false ||
						element.trend.rate == 0 ||
						element.trend.years == 0
					) {
						element.trend_text = "";
					} else {
						element.trend_text = trend;
					}
					//adrress
					if (element.address == 0) {
						element.address = "";
					}
				});
			},
			async loadConfig() {
				await this.$store.dispatch("loadConfig");
			},
			upOrDown_deal(trend_text) {
				if (trend_text.includes("-")) {
					//return "/images/arrowRed.svg";
					return `<svg xmlns="http://www.w3.org/2000/svg" width="12px" height="12px" viewBox="0 0 12 12" version="1.1">
							<title>tooltip 16 copy</title>
							<g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
								<g transform="translate(-1210.000000, -811.000000)">
									<g transform="translate(1209.000000, 810.000000)">
										<g transform="translate(7.000000, 7.000000) rotate(-180.000000) translate(-7.000000, -7.000000)">
											<rect fill="#FF0000" x="6" y="3" width="2" height="10" rx="1"/> <!-- Change color to red -->
											<polyline stroke="#FF0000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" transform="translate(7.000000, 5.000000) rotate(-270.000000) translate(-7.000000, -5.000000)" points="10 10 4 5 10 0"/> <!-- Change color to red -->
										</g>
									</g>
								</g>
							</g>
						</svg>
						`;
				} else {
					//return "/images/arrowGreen.svg";
					return `<svg xmlns="http://www.w3.org/2000/svg" width="12px" height="12px" viewBox="0 0 12 12" version="1.1">
							<title>green arrow up</title>
							<g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
								<g transform="translate(-1210.000000, -811.000000)">
									<g transform="translate(1209.000000, 810.000000)">
										<g transform="translate(7.000000, 7.000000) translate(-7.000000, -7.000000)">
											<rect fill="#66bb6a" x="6" y="3" width="2" height="10" rx="1"/>
											<polyline stroke="#66bb6a" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" transform="translate(7.000000, 5.000000) rotate(90.000000) translate(-7.000000, -5.000000)" points="10 10 4 5 10 0"/>
										</g>
									</g>
								</g>
							</g>
						</svg>

						`;
				}
			},
			upOrDown_color(trend_text) {
				if (trend_text.includes("-")) {
					return { color: "#E57373" };
				} else {
					return { color: "#66BB6A" };
				}
			},
		},
		mounted() {
			var appVue = this;
			if (appVue.$store.state.config == null) {
				appVue.loadConfig().then(() => {
					appVue.summaryTypeName = appVue.mixin_summaryTypeName(appVue);
				});
			} else {
				appVue.summaryTypeName = appVue.mixin_summaryTypeName(appVue);
			}
			// loadConfig
			//appVue.loadConfig().then(() => {
				//appVue.summaryTypeName = appVue.mixin_summaryTypeName(appVue);

				var view = appVue.$route.query.view;
				var id = appVue.$route.query.id;

				var baseNames = {
					neighborhood: "neighborhoodId",
					settlement: "settlmentID",
					street: "streetCode",
					address: "addressId",
					kparcel_all: "kParcelName",
				};

				appVue.base_name = baseNames[view];
				appVue.base_id = id;
				// console.log("base_name", appVue.base_name);	
				// console.log("base_id", appVue.base_id);


				// setTimeout(() => {
				// 	var appVue = this;
				// 	console.log("base_level", appVue.$store.state.base_level);
				// 	console.log("base_level_id", appVue.$store.state.base_level_id);
				// 	console.log("base_name", appVue.$store.state.base_name);
				// 	console.log("base_id", appVue.$store.state.base_id);
					
				// }, 1000);

				// // getInfo
				// const types = {
				// 	street: "street_id",
				// 	neighborhood: "neigh_id",
				// 	kparcel_all: "parcel_id",
				// 	address: "addr_id",
				// 	polygon_id: "polygon_id",
				// };

				// var api_base = appVue.$store.state.config.api_base;

				// const payload = {
				// 	//{ "base_name":  'addressid', "base_id": 53711814 }
				// 	base_name: types[view],
				// 	base_id: id,
				// };
				// var options = {
				// 	method: "POST",
				// 	headers: {
				// 		"Content-Type": "application/json",
				// 	},
				// 	body: JSON.stringify(payload),
				// };

				// fetch(api_base + "/GetInfo", options)
				// 	.then((response) => response.json())
				// 	.then((data) => {
				// 		if (data.base_level == "neighborhood") {
				// 			appVue.base_level = "neighborhoodId";
				// 			appVue.base_level_id = data.neigh_id;
				// 			appVue.base_name = "neighborhoodId";
				// 			appVue.base_id = data.neigh_id;
				// 		} else if (data.base_level == "settlement") {
				// 			appVue.base_level = "settlmentID";
				// 			appVue.base_level_id = data.setl_id;
				// 			appVue.base_name = "settlmentID";
				// 			appVue.base_id = data.setl_id;
				// 		} else {
				// 			return;
				// 		}
				// 		appVue.fetchData();
				// 	})
				// 	.catch((error) => console.error(error));
			//});
		},
		watch: {
			selectedDeals() {
				//currentTransactions
				return this.currentTransactions;
			},
			showAssetTypes: function (val) {
				if (val) {
					this.showDealsPeriods = false;
					this.showDealTypes = false;
				}
			},
			showDealsPeriods: function (val) {
				if (val) {
					this.showAssetTypes = false;
					this.showDealTypes = false;
				}
			},
			showDealTypes: function (val) {
				if (val) {
					this.showAssetTypes = false;
					this.showDealsPeriods = false;
				}
			},
		},
		computed: {
			isMobile() {
				return window.innerWidth < 1024;
			},
			checkRouteType() {
				var st = this.$route.name;
				return st;
			},
			checkAddress() {
				var addrs = [];
				this.deals.forEach(function (deal) {
					if (!addrs.includes(deal.address)) {
						addrs.push(deal.address);
					}
				});

				var addrsStr = addrs.join(", ");
				return addrsStr;
			},
			roomsDisplay() {
				if (this.selectedRooms.length > 0) {
					return this.selectedRooms.join(", ") + " חדרים";
				} else {
					return "כל החדרים";
				}
			},
			roundPages() {
				if (this.deals.length != this.countDealsAll) {
					return Math.round(this.countDealsAll / 10);
				}
				return Math.round(this.total / 10);
				//}
			},

			countDeals() {
				if (this.selectedRooms.length > 0) {
					//filter this.deals with selected rooms
					return this.deals.filter((deal) =>
						this.selectedRooms.includes(deal.roomNum),
					).length;
				} else {
					return this.deals.length;
				}
			},
			selectedDeals() {
				// take the first 10 rows from deals (starting from page value)
				var returnDeals = this.deals;
				if (this.streetId != null) {
					returnDeals = this.deals.filter(
						(deal) => deal.streetCode == this.streetId,
					);
				}
				// this.countDealsAll = returnDeals.length;
				// this.total = returnDeals.length;

				return returnDeals.slice(
					(this.page - 1) * 10,
					(this.page - 1) * 10 + 10,
				);
			},
			resultTypeDesc() {
				var st = this.$route.name;
				if (st == "polygonid") {
					return "כתובת";
				} else if (st == "street") {
					return "רחוב";
				} else if (st == "neighborhood") {
					return "שכונה";
				} else if (st == "settlement") {
					return "יישוב";
				} else {
					return "כתובת";
				}
			},
			selectedYears() {
				if ( this.$refs.graph_card == null) {
					return null;
				}
				if (this.selectedTab == "all") {
					return this.$refs.graph_card.years_all;
				} else if (this.selectedTab == "3") {
					return this.$refs.graph_card.years_all_3;
				} else if (this.selectedTab == "4") {
					return this.$refs.graph_card.years_all_4;
				} else if (this.selectedTab == "5") {
					return this.$refs.graph_card.years_all_5;
				} else {
					return null;
				}
			},
			getLastYearAvgPrice() {
				if (this.selectedTab == "all") {
					if (this.$store.state.lastYearAvgPrice == null) {
						return null;
					}
					return this.$store.state.lastYearAvgPrice.toLocaleString("he-IL");
				} else if (this.selectedTab == "3") {
					if (this.$store.state.lastYearAvgPrice_3 == null) {
						return null;
					}
					return this.$store.state.lastYearAvgPrice_3.toLocaleString("he-IL");
				} else if (this.selectedTab == "4") {
					if (this.$store.state.lastYearAvgPrice_4 == null) {
						return null;
					}
					return this.$store.state.lastYearAvgPrice_4.toLocaleString("he-IL");
				} else if (this.selectedTab == "5") {
					if (this.$store.state.lastYearAvgPrice_5 == null) {
						return null;
					}
					return this.$store.state.lastYearAvgPrice_5.toLocaleString("he-IL");
				} else {
					return null;
				}
			},
			getLastQuarterlyAvgPrice() {
				if (this.selectedTab == "all") {
					if (this.$store.state.lastQuarterlyAvgPrice == null) {
						return null;
					}
					return this.$store.state.lastQuarterlyAvgPrice.toLocaleString(
						"he-IL",
					);
				} else if (this.selectedTab == "3") {
					if (this.$store.state.lastQuarterlyAvgPrice_3 == null) {
						return null;
					}
					return this.$store.state.lastQuarterlyAvgPrice_3.toLocaleString(
						"he-IL",
					);
				} else if (this.selectedTab == "4") {
					if (this.$store.state.lastQuarterlyAvgPrice_4 == null) {
						return null;
					}
					return this.$store.state.lastQuarterlyAvgPrice_4.toLocaleString(
						"he-IL",
					);
				} else if (this.selectedTab == "5") {
					if (this.$store.state.lastQuarterlyAvgPrice_5 == null) {
						return null;
					}
					return this.$store.state.lastQuarterlyAvgPrice_5.toLocaleString(
						"he-IL",
					);
				} else {
					return null;
				}
			},
			upOrDown() {
				if (this.getPriceDifferencePercentage < 0) {
					return "ירידת מחירים";
				} else {
					return "עליית מחירים";
				}
			},
			getPriceDifferencePercentage() {
				if (this.selectedTab == "all") {
					return this.$store.state.priceDifferencePercentage;
				} else if (this.selectedTab == "3") {
					return this.$store.state.priceDifferencePercentage_3;
				} else if (this.selectedTab == "4") {
					return this.$store.state.priceDifferencePercentage_4;
				} else if (this.selectedTab == "5") {
					return this.$store.state.priceDifferencePercentage_5;
				} else {
					return null;
				}
			},
		},
	};
</script>

<style scoped>
	button:disabled {
		cursor: wait;
	}
	.scrollmenu-container {
		/* ... other styles ... */

		/* Add transition for smooth scroll animation */
		transition: scroll-left 0.3s ease-in-out;
	}
	.grid-container {
		display: grid;
		grid-template-columns: 10% 80% 10%; /* Three columns: 10%, 80%, 10% */
		align-items: center; /* Optional: Centers items vertically within the grid container */
		/* ... other styles ... */
	}

	div.scrollmenu {
		display: block;
		overflow: auto;
		white-space: nowrap;
		z-index: -1;
		margin-top: 120px;
	}

	div.scrollmenu a {
		display: inline-block;
		color: white;
		text-align: center;
		padding: 14px;
		text-decoration: none;
		z-index: -1;
		color: black;
	}

	div.scrollmenu a:hover {
		background-color: tr;
		z-index: -1;
	}

	.details-row {
		display: none;
	}
	.fade-enter-active {
		transition: opacity 0.5s;
	}

	.fade-enter,
	.fade-leave-active {
		opacity: 0;
	}

	.filter_circle {
		width: 20px;
		height: 20px;
		border-radius: 50%;
		border: 2px solid blue;
		border-top: 2px solid transparent;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%) rotate(0deg);
		animation: spin 2s linear infinite;
	}

	.sort_circle {
		width: 20px;
		height: 20px;
		border-radius: 50%;
		border: 2px solid blue;
		border-top: 2px solid transparent;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%) rotate(0deg);
		animation: spin 2s linear infinite;
	}

	.filter_rooms_circle {
		width: 20px;
		height: 20px;
		border-radius: 50%;
		border: 2px solid blue;
		border-top: 2px solid transparent;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%) rotate(0deg);
		animation: spin 2s linear infinite;
	}

	@keyframes spin {
		0% {
			transform: translate(-50%, -50%) rotate(0deg);
		}
		100% {
			transform: translate(-50%, -50%) rotate(360deg);
		}
	}

	.filter_circle {
		width: 20px;
		height: 20px;
		border-radius: 50%;
		border: 2px solid blue;
		border-top: 2px solid transparent;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%) rotate(0deg);
		animation: spin 2s linear infinite;
	}

	.sort_circle {
		width: 20px;
		height: 20px;
		border-radius: 50%;
		border: 2px solid blue;
		border-top: 2px solid transparent;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%) rotate(0deg);
		animation: spin 2s linear infinite;
	}

	.filter_rooms_circle {
		width: 20px;
		height: 20px;
		border-radius: 50%;
		border: 2px solid blue;
		border-top: 2px solid transparent;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%) rotate(0deg);
		animation: spin 2s linear infinite;
	}

	@keyframes spin {
		0% {
			transform: translate(-50%, -50%) rotate(0deg);
		}
		100% {
			transform: translate(-50%, -50%) rotate(360deg);
		}
	}

	#wrapper {
		position: relative;
		/*background:#333;*/
		height: 100%;
	}

	.profile-main-loader {
		position: fixed !important;
		left: 50%;
		right: 50%;
		top: 50%;
		bottom: 50%;
		width: 300px;
		height: 300px; /* assuming you want it square */
		margin-left: -100px; /* half of the width */
		margin-top: -100px; /* half of the height */
		z-index: 900 !important;
	}

	.profile-main-loader .loader {
		position: relative;
		margin: 0px auto;
		width: 150px;
		height: 150px;
	}
	.profile-main-loader .loader:before {
		content: "";
		display: block;
		padding-top: 100%;
	}

	.circular-loader {
		-webkit-animation: rotate 2s linear infinite;
		animation: rotate 2s linear infinite;
		height: 100%;
		-webkit-transform-origin: center center;
		-ms-transform-origin: center center;
		transform-origin: center center;
		width: 100%;
		position: absolute;
		top: 0;
		left: 0;
		margin: auto;
	}

	.loader-path {
		stroke-dasharray: 150, 200;
		stroke-dashoffset: -10;
		-webkit-animation:
			dash 1.5s ease-in-out infinite,
			color 6s ease-in-out infinite;
		animation:
			dash 1.5s ease-in-out infinite,
			color 6s ease-in-out infinite;
		stroke-linecap: round;
	}

	@-webkit-keyframes rotate {
		100% {
			-webkit-transform: rotate(360deg);
			transform: rotate(360deg);
		}
	}

	@keyframes rotate {
		100% {
			-webkit-transform: rotate(360deg);
			transform: rotate(360deg);
		}
	}
	@-webkit-keyframes dash {
		0% {
			stroke-dasharray: 1, 200;
			stroke-dashoffset: 0;
		}
		50% {
			stroke-dasharray: 89, 200;
			stroke-dashoffset: -35;
		}
		100% {
			stroke-dasharray: 89, 200;
			stroke-dashoffset: -124;
		}
	}
	@keyframes dash {
		0% {
			stroke-dasharray: 1, 200;
			stroke-dashoffset: 0;
		}
		50% {
			stroke-dasharray: 89, 200;
			stroke-dashoffset: -35;
		}
		100% {
			stroke-dasharray: 89, 200;
			stroke-dashoffset: -124;
		}
	}
	@-webkit-keyframes color {
		0% {
			stroke: #1990d4;
		}
		40% {
			stroke: #1990d4;
		}
		66% {
			stroke: #1990d4;
		}
		80%,
		90% {
			stroke: #1990d4;
		}
	}
	@keyframes color {
		0% {
			stroke: #1990d4;
		}
		40% {
			stroke: #1990d4;
		}
		66% {
			stroke: #1990d4;
		}
		80%,
		90% {
			stroke: #1990d4;
		}
	}

	.loading-container {
		display: flex;
		justify-content: center; /* Center horizontally */
		align-items: center; /* Center vertically */
		height: 100vh; /* Optional: Set the height to 100% of the viewport height */
	}

	.loader-svg {
		width: 200px; /* Adjust the width of the SVG as needed */
		height: 200px; /* Adjust the height of the SVG as needed */
	}
</style>
